export default __webpack_public_path__ + "static/media/fieldWhite.ea0efad8.svg";